export const environment = {
    // hostname: 'https://fynextinnovations.in/storage/admin/api'
    hostname:'https://www.avatisafestorage.com/admin/api'
    //hostname:"http://localhost/storage/api/"
}